module.exports = __webpack_public_path__ + "common/icon-question-white-228e42c279519f5642e1b0de94ce9869.svg";